var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_695)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09606 23.6434C15.5262 25.2467 22.0381 21.3339 23.6409 14.9045H23.6409L23.6408 14.9046C25.2438 8.475 21.3313 1.96199 14.9016 0.359121C8.47348 -1.24375 1.96159 2.66933 0.359423 9.09939C-1.24415 15.5282 2.66863 22.0405 9.09606 23.6434ZM14.6523 7.26311C16.315 7.83582 17.531 8.69433 17.2921 10.2914L17.2921 10.2913L17.2926 10.2916C17.1197 11.4607 16.4716 12.0267 15.6111 12.2252C16.7925 12.8403 17.3937 13.7836 16.821 15.4189C16.1103 17.4501 14.4217 17.6215 12.176 17.1965L11.6311 19.3806L10.3141 19.0525L10.852 16.8977C10.5106 16.8128 10.1618 16.7229 9.80248 16.6253L9.26279 18.7903L7.94737 18.4622L8.49233 16.2739C8.36575 16.2416 8.23837 16.2084 8.11006 16.1749C7.9265 16.1271 7.74106 16.0787 7.5534 16.0317L5.8396 15.6044L6.49344 14.0969C6.49344 14.0969 7.46382 14.3549 7.45062 14.3358C7.82347 14.4281 7.9889 14.185 8.05407 14.023L8.91528 10.5703C8.94995 10.5786 8.98373 10.5871 9.01622 10.5952C9.02919 10.5985 9.04195 10.6016 9.05448 10.6048C9.00192 10.5836 8.95429 10.5701 8.91757 10.5608L9.53199 8.09616C9.548 7.81634 9.45156 7.46332 8.91827 7.33022C8.93886 7.31643 7.9618 7.09246 7.9618 7.09246L8.31212 5.68588L10.1282 6.13939L10.1267 6.14619C10.3997 6.21412 10.6811 6.27859 10.9676 6.34382L11.5073 4.18109L12.8234 4.50924L12.2945 6.62962C12.6479 6.71028 13.0035 6.79165 13.3497 6.87799L13.8748 4.77152L15.1917 5.09967L14.6523 7.26311ZM10.4867 15.107C11.5612 15.3908 13.9098 16.0111 14.2832 14.5107H14.2832C14.6657 12.9768 12.3885 12.4657 11.277 12.2163C11.1527 12.1884 11.043 12.1638 10.9532 12.1413L10.23 15.0404C10.3037 15.0587 10.39 15.0815 10.4867 15.107ZM11.5 10.8708C12.3958 11.1099 14.3501 11.6314 14.6904 10.2677H14.6906C15.0381 8.87305 13.1389 8.45256 12.2113 8.2472C12.1069 8.22409 12.0149 8.20371 11.9397 8.18497L11.284 10.8142C11.3459 10.8297 11.4186 10.8491 11.5 10.8708Z",
    fill: "url(#paint0_linear_163_695)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_695",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24.0027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5263B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B266F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.0027,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.827bb00ef4edc750b8eb6f4d43e35a01.svg";
export { ForwardRef as ReactComponent };